var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052b4"
    },
    width: 512,
    height: 341.337,
    y: 85.334
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f0f0f0"
    },
    points: "512 295.883 202.195 295.883 202.195 426.666 183.652 426.666 140.978 426.666 122.435 426.666 122.435 295.883 0 295.883 0 277.329 0 234.666 0 216.111 122.435 216.111 122.435 85.329 140.978 85.329 183.652 85.329 202.195 85.329 202.195 216.111 512 216.111 512 234.666 512 277.329"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "512 234.666 512 277.329 183.652 277.329 183.652 426.666 140.978 426.666 140.978 277.329 0 277.329 0 234.666 140.978 234.666 140.978 85.329 183.652 85.329 183.652 234.666"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.ad7ac62aa068e3276a083dddf358f4dc.svg";
export { ForwardRef as ReactComponent };